import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d18a5cbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-button" }

import closeIcon from "@/assets/SVG/closeIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomIconButton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(closeIcon)
  ]))
}
}

})